import { rem } from 'polished';
import styled from 'styled-components';
import { media } from 'baseline-ui/layout';

const AdminMainFooterOuterWrapper = styled.div`
    margin-top: 2rem;
`;

export default AdminMainFooterOuterWrapper;
